import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DropzoneModule } from '../directives/dropzone/dropzone.module';
import { NeighboursComponent } from './neighbours.component';
import { NgxJsonViewerModule } from 'ngx-json-viewer';


@NgModule({
  declarations: [
    NeighboursComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgxJsonViewerModule,
    DropzoneModule
  ],
  exports: [
    NeighboursComponent
  ]
})
export class NeighboursModule { }